import { IStorageEngine, LocalStorage, CookieStorage } from './engines';
import is, { isNullOrUndefined } from '../../comparator/is';
type targetType = string | number | object | symbol;

export class QpStorage {
  private _STORAGE: IStorageEngine;

  constructor(type: 'local' | 'cookie', appId: string, frameWindow?: Window) {
    //根据type构造_STORAGE
    if (type == 'local') {
      this._STORAGE = new LocalStorage(appId, frameWindow);
    } else if (type == 'cookie') {
      this._STORAGE = new CookieStorage(appId);
    } else {
      // 暂不支持的storage类型
      throw new TypeError(`${type} is not support`);
    }
  }

  @toLowerKey()
  public set(key: string, value: any, expire?: Date) {
    if (isNullOrUndefined(key)) {
      console.warn('...');
      return;
    }
    // let storeValue = this.serialize(value);
    const storeValue = value;
    if (!isNullOrUndefined(storeValue)) {
      this._STORAGE.set(key, storeValue, expire);
    } else {
      this.remove(key);
    }
  }

  @toLowerKey()
  public get<T>(key: string, defaultValue?: T): T | null {
    if (!isNullOrUndefined(key)) {
      if (this.hasKey(key) && !this.isExpried(key)) {
        const value = this.deserialize(this._STORAGE.get(key), defaultValue);
        if (!isNullOrUndefined(value)) {
          return value as T;
        }
      }
    }

    return null;
  }

  @toLowerKey()
  public hasKey(key: string): boolean {
    if (isNullOrUndefined(key)) {
      return false;
    }
    return this._STORAGE.hasKey(key);
  }

  @toLowerKey()
  public isExpried(key: string): boolean {
    if (isNullOrUndefined(key)) {
      return false;
    }
    if (!this.hasKey(key)) {
      return false;
    }
    return this._STORAGE.isExpried(key);
  }

  @toLowerKey()
  public remove(key: string) {
    if (isNullOrUndefined(key)) {
      return;
    }
    // 检查是否存在
    if (!this.hasKey(key)) {
      return;
    }
    this._STORAGE.remove(key);
  }

  public clearAll() {
    this._STORAGE.clearAll();
  }

  private serialize(target: targetType): string {
    // if (isString(target)) {
    //   return target
    // }
    return JSON.stringify(target);
  }

  private deserialize<T>(source: string | null, defaultValue?: T): T | undefined | string {
    if (isNullOrUndefined(source)) {
      return defaultValue;
    }
    let val: string | undefined = '';
    try {
      val = JSON.parse(source!);
    } catch (e) {
      val = source;
    }
    return val !== undefined ? val : defaultValue;
  }
}

/**
 * 将Key统一处理成小写，避免有人不了解规则，定义出来Key不规范
 * @param keyPosition
 * @returns
 */
function toLowerKey(keyPosition: number = 0) {
  return function (target: any, propertyName: string, descriptor: any): void {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]) {
      let value = args[keyPosition];

      if (is.string(value)) {
        value = value.toLowerCase();
        args[keyPosition] = value;
      }
      const result = originalMethod.apply(this, args);
      return result;
    };

    return descriptor;
  };
}
